import { useQuery } from "@tanstack/react-query";
import * as Api from "./map-routes";
import { CalculateRouteRequest } from "@/common/components/tracking-map/MapTypes";

export function calculateRoute(request: CalculateRouteRequest[]){
  const result = useQuery<ReturnTypePromise<typeof Api.calculateRoute>, Error>(
    ['order', request],
    () => Api.calculateRoute(request),
    {
      useErrorBoundary: false,
    }
  );

  return {...result, data: result.data};
}